import { Icon, IconProps } from "../";

export const ArrowDownwardIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4697 11.9697C17.7626 11.6768 18.2374 11.6768 18.5303 11.9697C18.8232 12.2626 18.8232 12.7374 18.5303 13.0303L12.5303 19.0303C12.2374 19.3232 11.7626 19.3232 11.4697 19.0303L5.46967 13.0303C5.17678 12.7374 5.17678 12.2626 5.46967 11.9697C5.76256 11.6768 6.23744 11.6768 6.53033 11.9697L11.25 16.6893V5.25C11.25 4.83579 11.5858 4.5 12 4.5C12.4142 4.5 12.75 4.83579 12.75 5.25V16.6893L17.4697 11.9697Z"
      />
    </Icon>
  );
};
